import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { List, ListItem, Tooltip } from "@mui/material";
import { autovioColors } from "./backofficeTheme";

export function WarningIndicator(props: { warnings: Array<string> }) {
  const { warnings } = props;
  return (
    <Tooltip
      title={
        <List sx={{ py: 0.5, listStyleType: warnings.length > 1 ? "circle" : "none" }}>
          {warnings.map((it) => (
            <ListItem
              key={it}
              sx={{
                mx: 1,
                px: 0,
                py: 0.5,
                display: "list-item",
                fontSize: "11px",
                fontWeight: "400",
              }}
            >
              {it}.
            </ListItem>
          ))}
        </List>
      }
    >
      <WarningAmberRoundedIcon sx={{ width: "16px", height: "16px", color: autovioColors.red }} />
    </Tooltip>
  );
}
